import { useTranslator } from 'tradera-lang/translate';
import { MEMBER_ACCOUNT_STATE } from './member-account-state';
import React from 'react';

export const SuspendedInfo = ({ model }) => {
    const { t } = useTranslator();
    if (model.accountState === MEMBER_ACCOUNT_STATE.PERMANENTLY_SUSPENDED) {
        return (
            <section className="warning-message">
                <span className="warning--before warning-message-icon" />
                <a
                    href="http://info.tradera.com/hjalp/vad-innebar-kontot-ar-avaktiverat-av-tradera/"
                    className="warning-message-text">
                    {t('profile_memberSuspended')}
                </a>
            </section>
        );
    } else if (
        model.accountState === MEMBER_ACCOUNT_STATE.TEMPORARY_SUSPENDED
    ) {
        return (
            <section className="information-message">
                <span className="info--before information-message-icon" />
                <a
                    href="http://info.tradera.com/hjalp/vad-innebar-kontot-ar-avaktiverat-av-tradera/"
                    className="information-message-text">
                    {t('profile_memberSuspended')}
                </a>
            </section>
        );
    }
    return null;
};
